import { People } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { flownectColors } from "@components/jobs2/jobs-calendar/const";
import { WorkerCard } from "./EventJobWorkerCard";

export const WorkforceSection = ({ workforce, baseColor, companyTimeZone, now, compact }) => (
    <Box>
        <Stack direction="row" spacing={1} alignItems="center">
            <People sx={{ fontSize: compact ? 16 : 16, color: baseColor }} />
            <Typography
                variant="caption"
                sx={{
                    color: flownectColors.gray[700],
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                    fontSize: compact ? 11 : "0.7rem",
                    lineHeight: 1.1,
                }}
            >
                Workforce ({workforce.length})
            </Typography>
        </Stack>

        <Box
            sx={{
                display: "flex",
                flexWrap: compact ? "wrap" : "nowrap",
                justifyContent: "flex-start",
                gap: compact ? 1 : 1.5,
                mt: 0.35,
                overflowX: "auto",
                "&::-webkit-scrollbar": { height: 6 },
                "&::-webkit-scrollbar-track": { bgcolor: flownectColors.gray[100], borderRadius: 3 },
                "&::-webkit-scrollbar-thumb": { bgcolor: flownectColors.gray[400], borderRadius: 3 },
            }}
        >
            {workforce.map((worker, index) => (
                <WorkerCard
                    key={index}
                    worker={worker}
                    baseColor={baseColor}
                    companyTimeZone={companyTimeZone}
                    now={now}
                    compact={compact}
                />
            ))}
        </Box>
    </Box>
);
